// 存储每个资源的加载状态
const jsLoading = new Map();

// 资源对应的加载Promise
const jsPromises = new Map();

// 加载函数
async function loadJS(name, fun) {
  // 如果已加载直接返回
  if (jsLoading.get(name)) {
    fun && fun();
    return;
  }

  // 没加载则创建新的Promise并锁定
  if (!jsPromises.has(name)) {
    jsPromises.set(
      name,
      new Promise((resolve, reject) => {
        // 动态插入script标签加载JS
        const script = document.createElement('script');
        script.src = name;
        script.defer = true;
        script.onload = () => {
          jsLoading.set(name, true);
          resolve();
        };
        script.onerror = () => reject(`Load ${name} failed!`);

        document.head.appendChild(script);
      })
    );
  }

  // 等待Promise resolve
  await jsPromises.get(name);
  fun && fun();
}

module.exports = { loadJS };
